export const noPreview = "jn$Xid";
export default {noPreview};